import { colors } from 'ui/theme/colors';
import { getColor } from 'ui/icons/utils';
import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const KeyU = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M2.86075 16C1.03218 16 0.0996094 15.0852 0.0996094 13.2739V2.71698C0.0996094 0.914808 1.03218 0 2.86075 0H13.3476C15.1762 0 16.0996 0.914808 16.0996 2.71698V13.2739C16.0996 15.0852 15.1762 16 13.3476 16H2.86075ZM2.90647 14.5089H13.2928C14.1339 14.5089 14.6093 14.0606 14.6093 13.1824V2.81761C14.6093 1.93939 14.1339 1.49114 13.2928 1.49114H2.90647C2.06532 1.49114 1.59904 1.93939 1.59904 2.81761V13.1824C1.59904 14.0606 2.06532 14.5089 2.90647 14.5089ZM8.09961 12.0389C6.0699 12.0389 4.70761 10.8679 4.70761 9.06575V4.69297C4.70761 4.17153 4.9819 3.86964 5.4299 3.86964C5.90532 3.86964 6.17047 4.18067 6.17047 4.69297V8.92853C6.17047 10.0903 6.93847 10.8313 8.09961 10.8313C9.26989 10.8313 10.0379 10.0903 10.0379 8.92853V4.69297C10.0379 4.18067 10.303 3.86964 10.7602 3.86964C11.2265 3.86964 11.5008 4.17153 11.5008 4.69297V9.06575C11.5008 10.8679 10.1293 12.0389 8.09961 12.0389Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
